<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="750px">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title>
            <v-panel>
                  <span style="font-size: 20px;">
                     {{ !data.id ? "Editar Webhook" : "Editar Webhook" }}    
                  </span>
            </v-panel>
          </v-card-title>
          <v-card-text>
            <v-container>
                          <v-form ref="form">
                              <v-row>
  
                                  <v-col cols="12">                
                                      <v-text-field
                                          v-model="data.description"
                                          label="Descripcion"
                                          autocomplete="none"
                                          :rules="[validationRules.required]"
                                          max="200"
                                      />
                                  </v-col>

                                    <v-col cols="12">                
                                     <v-textarea 
                                          v-model="data.example"
                                          label="Ejemplo"
                                          autocomplete="none"
                                          :rules="[validationRules.required]"
                                          max="200"
                                      />
                                  </v-col>
                              </v-row>
                          </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> 
  
            <ConfirmDialog ref="dlgConfirm"
              v-bind:title="$t('wkt.admin.document-category.edit-document-category.confirm-dialog.title')"
              v-bind:message="$t('wkt.admin.document-category.edit-document-category.confirm-dialog.text')"
              v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
              v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
              v-on:confirmed="deleteItem()"
          />
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import ConfirmDialog from '../../common/ConfirmDialog'
import api from '../../../api/worktime'
//import gwt from '../../../api/gwt'

export default {
   name: 'WebhooksDialog',
   mixins: [BaseModule],
   components: {
      ConfirmDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         data: {}
      }
   },
   methods: {

       // eslint-disable-next-line no-unused-vars
      open: function (action, payload) {

         this.showDialog = true;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

    

         this.loading = true;
         api.getWebhookById(payload, res => {
            this.data = res;
            this.loading = false;
         }, error => {
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         })
      },
      onSave: function () {
         if (!this.$refs.form.validate()) {
            return;
         }

         this.loading = true;
         // eslint-disable-next-line no-unused-vars
         api.storeWebhook(this.data,res => {
                  this.loading = false;
                  this.$emit('refresh');
                  this.showDialog = false;
            },
            error => {
               this.$log.error(error);
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            });
      },
      confirmDelete() {
         this.$refs.dlgConfirm.confirm(this.data);
      },
      deleteItem() {
        this.loading = true;
        // eslint-disable-next-line no-unused-vars
         api.deleteDocumentCategory(this.data.id, res => {
               this.showDialog = false;
               this.loading = false;
               this.$emit('refresh');
            },
            (error) => {
               this.loading = false;
               this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
            }
         );
      }
   },
}
</script>